export enum StatusColorEnum {
  "pending approval" = "bg-gray-light",
  "active" = "bg-green",
  "suspended" = "bg-gray-dark",
  "deactivated" = "bg-gray-dark",
  "refused" = "bg-red",
}
